var map = {
	"./pokoj/IMG_2971.jpg": 9835,
	"./pokoj/IMG_2972.jpg": 2860,
	"./pokoj/IMG_2973.jpg": 4473,
	"./pokoj/IMG_2980.jpg": 159,
	"./pokoj/IMG_2981.jpg": 2098,
	"./pokoj/IMG_2982.jpg": 8029,
	"./pokoj/IMG_2983.jpg": 5808,
	"./pokoj/IMG_2984.jpg": 2083,
	"./pokoj/IMG_2985.jpg": 8950,
	"./pokoj/IMG_2986.jpg": 6705,
	"./pokoj/IMG_2987.jpg": 2372,
	"./pokoj/IMG_2988.jpg": 1431,
	"./pokoj/IMG_2989.jpg": 5594,
	"./pokoj/IMG_2990.jpg": 6384,
	"./pokoj/IMG_2999.jpg": 5189,
	"./pokoj/IMG_5223.jpg": 9104,
	"./pokoj/IMG_5230.jpg": 2240,
	"./pokoj/IMG_5231.jpg": 4461,
	"./pokoj/IMG_5232.jpg": 8530,
	"./pokoj/IMG_5233.jpg": 6591,
	"./pokoj/IMG_5234.jpg": 8804,
	"./pokoj/IMG_5235.jpg": 3137,
	"./pokoj/IMG_5236.jpg": 5382,
	"./pokoj/IMG_5237.jpg": 8515,
	"./pokoj/IMG_5238.jpg": 408,
	"./pokoj/IMG_5239.jpg": 8277,
	"./pokoj/IMG_5240.jpg": 6205,
	"./pokoj/IMG_5241.jpg": 5280,
	"./pokoj/IMG_5242.jpg": 9615,
	"./pokoj/IMG_5244.jpg": 2529,
	"./pokoj/IMG_5245.jpg": 6423,
	"./pokoj/IMG_5246.jpg": 3283,
	"./pokoj/IMG_5247.jpg": 4758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5632;